export const httpUrlToWebSocketUrl = (url: string) => url.replace(/(http)(s)?/, 'ws$2')
export const webSocketUrlToHttpUrl = (url: string) => url.replace(/(ws)(s)?/, 'http$2')
